export default {
    id: null,
    order_id: null,
    link: null,
    comment: null,
    archive: null,
    order: null,
    show_date: null,
    created_at: null,
    img: null
}
